/**
 * Steps shared block scripts
 * This file gets shared between the
 * theme and editor.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

// loop through any steps groups we have
const steps = document.querySelectorAll('.steps');
if(steps.length){
	steps.forEach((step, i) => {

		// const get this thing's ID
		const id = step.id;

		// get the major sub elements
		const sections = step.querySelectorAll('.steps__section')
		const labels = step.querySelectorAll('.steps__label');

		// link to each section
		sections.forEach((section, i) => {
			if(section) {
				const subId = `${id}-${i}`;
				section.id = subId;
				labels[i].firstElementChild.href = `#${subId}`;
			}
		});

		// use on-scroll animations
		gsap.registerPlugin(ScrollTrigger);

		// un-toggle all but the requested item
		const allButOneToggle = (index, els) => {
			els.forEach((el, i) => {
				el.classList.toggle('is-active', index === i)
			});
		};

		// set up animations
		sections.forEach((el, i) => {

			let tl = gsap.timeline();
			tl
			.from(el.querySelector('.steps__content'), {
				y: '85%',
				opacity: 0,
				scale: 0.95,
			})
			.from(el.querySelector('.steps__title'), {y: '-100%', opacity: 0, scale: 0.95}, "<")

			ScrollTrigger.create({
				trigger: el,
				start: '0% 50%',
				end: '100% 80%',
				animation: tl,
				scrub: 1,
				onLeaveBack: () => allButOneToggle(i - 1, labels),
				onEnter: () => allButOneToggle(i, labels),
				// /*DEBUG*/markers: true,id: `pin-${i}`,
			})

		});

	})
}
